export default __webpack_public_path__ + "static/media/feature_3.e2677073.png";